<div class="login-split-container min-vh-100 d-flex">
  
  <!-- Partie Gauche : Image Immersive & Message Site -->
  <div class="login-image-side d-none d-md-flex flex-column justify-content-end p-5 position-relative">
    <img src="image-4.jpg" class="login-bg-img" alt="">
    <div class="login-image-overlay"></div>
    <div class="login-site-message position-relative z-1 text-white">
      <h1 class="display-6 fw-bold m-0 text-truncate" [matTooltip]="currentSygmaSite">{{ currentSygmaSite }}</h1>
      <p class="text-white-50 small mt-2"></p>
    </div>
  </div>

  <!-- Partie Droite : Formulaire de connexion -->
  <div [class]="`${'custom-pattern-'+color} flex-grow-1 d-flex align-items-center justify-content-center`">
    <div class="custom-pattern-texture"></div>
  </div>
</div>
